var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-group"},[_c('headline',{staticClass:"mt-10"},[_vm._v(" "+_vm._s(_vm.$tc('rfid.rfid', 2))+" ")]),_c('v-row',[_c('v-col',[_c('tokens-manager',{attrs:{"member-id":_vm.member.id,"customer-id":_vm.member.customer.id,"organization-id":_vm.member.organization.id}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }